import { render } from "./CustomerVendorForm.vue?vue&type=template&id=5f6f0a66&scoped=true"
import script from "./CustomerVendorForm.vue?vue&type=script&lang=js"
export * from "./CustomerVendorForm.vue?vue&type=script&lang=js"

import "./CustomerVendorForm.vue?vue&type=style&index=0&id=5f6f0a66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f6f0a66"]])

export default __exports__